export default "__VITE_ASSET__Cfwz9BK___"